import { toast } from 'react-toastify';

export const REDUCER_GENERIC = "GENERIC"
const REDUCER_NOTIFICATION = "NOTIFICATION"

const generic = (state = [], action) => {
    switch (action.type) {
    case REDUCER_GENERIC: {
        state = {...state, ...action, isLoading: false, message: undefined}
        return state
    }
    case REDUCER_GENERIC+'_LOADING' : {
        state = {...state, isLoading: action.isLoading}
        return state
    }
    case REDUCER_GENERIC+'_ADD' : {
        if(state.data === undefined) {
            state.data = []
        }
        state.data.push(action.newData)
        state.expanded = action.newData.id
        state = {...state, ...action}
        return state
    }
    case REDUCER_GENERIC+'_DELETE' : {
        state.data = state.data.filter((item) => {
            if(item.id === action.deleteId) {
                return false
            }
            return true
        })
        state = {...state, ...action}
        return state
    }
    case REDUCER_GENERIC+'_PUT' : {
        if(state.putLoading === undefined) {
            state.putLoading = {}
        }
        state.putLoading[action.id] = action.isLoading
        state = {...state, ...action}
        return state
    }
    case REDUCER_GENERIC+'_ERROR' : {
        state = {...state, isLoading: false, message: action.message}
        toast.error(action.message, {});
        return state
    }
    case REDUCER_NOTIFICATION : {
        switch (action.messageType) {
            case "success":
                toast.success(action.message, {});
            break
            case "error":
                toast.error(action.message, {});
            break
        }
        
        return state
    }
    default:
        return state
    }
}
 
export default generic



// WEBPACK FOOTER //
// ./src/Redux/Reducers/generic.jsx